module.exports = __webpack_public_path__ + "media/images/bg/shapes/triangles-fc3e40a290a8ecb26613dd4e5765a2dd.svg";